import { Injectable } from '@angular/core';

@Injectable()
export class PaginationSizeService {

    /**
     * Método responsável por retornar as quantidades de itens que podem ser selecionadas na paginaçao da grid.
     */
    getQuantityItemsByPage() {
        return [5, 10, 15, 25, 50];
    }
}
